import { Component, EventEmitter, Input, OnInit, Output,signal } from '@angular/core';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ControllerService } from 'src/app/services/controller.service';
import { ControllerDetails, ControllerInfo } from 'src/app/models/common/controller-info.model';
import { DeviceOperationFilters, DeviceActionHistoryModel, groupedDeviceActionHistory } from 'src/app/models/common/device.model';
import { NgFor, NgIf } from '@angular/common';
import { DateTime } from 'luxon';
import { format, isToday, isYesterday, parseISO, formatDistanceToNow } from 'date-fns';
import { actionMetadataModel, OPERATION_CONFIGS, OPERATION_SCHEDULE_CONFIGS, OperationDisplayConfig, OperationInfoModel, ACTION_CONFIGS, FilterOption } from 'src/app/models/common/device-action-model';
import { AuthserviceService } from 'src/app/services/authservice.service';
import {MatExpansionModule} from '@angular/material/expansion';
@Component({
  selector: 'app-action-history-dashboard',
  standalone: true,
  imports: [NgFor, NgIf, MatExpansionModule],
  templateUrl: './action-history-dashboard.component.html',
  styleUrl: './action-history-dashboard.component.css'
})
export class ActionHistoryDashboardComponent implements OnInit {

  readonly panelOpenState = signal(false);

  @Input() showActionPopUp!:boolean
  @Input({required:true}) controllerDetails!:ControllerDetails
  @Output() closeModal = new EventEmitter()
  controller_info?:ControllerInfo
  
    rebootMessage!:string
    spinner:boolean = true
  
    isHidden:boolean = false
    operation_filters:string[] = []
    config!: OperationDisplayConfig;
    offset: number = 0;
    loading:boolean = false;
    allLoaded:boolean = false;
    echodiumStates: { [id: string]: boolean } = {};
    backwash_history: string[] = []
    operation: string = ""
    subOperation: string = ""
    popUp:boolean = false
    selectedActions: string[] = [];
    action_filters: FilterOption[] = [];
    isFilterSelected:boolean = true

    groupedDeviceActionHistory: groupedDeviceActionHistory[] = []
    
    deviceActionFilters!: DeviceOperationFilters;
    deviceActionHistory: DeviceActionHistoryModel[] = []




    constructor(private controllerService:ControllerService,private confirmationDialogService: ConfirmationDialogService,private auth: AuthserviceService,){}
  
    ngOnInit(): void {

      this.getActionFilters()
    }
  
  
  async getActionFilters(){
   


      this.deviceActionFilters = await this.controllerService.get_device_action_filters(
        this.controllerDetails.controller_uuid,
        this.controllerDetails.device_id!,
      )
      this.selectedActions = this.deviceActionFilters?.unique_filters.filter(f => ACTION_CONFIGS.map(c => c.value).includes(f));
            // Filter ACTION_CONFIGS based on those values
      this.action_filters = ACTION_CONFIGS.filter(config => 
        this.selectedActions.includes(config.value)
      );
 

      this.deviceActionHistory = await this.controllerService.get_device_action_history(
        this.controllerDetails.controller_uuid,
        this.controllerDetails.device_id!,
        this.selectedActions
      );
      // for fetching profile images
      this.auth.fetchImage(this.deviceActionHistory);
      this.historyGrouping();
     this.spinner = false



  }




  historyGrouping(){


        const groupedMap = new Map<string, DeviceActionHistoryModel[]>();

          this.deviceActionHistory.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

          for (const entry of this.deviceActionHistory) {
            const label = this.getFormattedLabel(entry.date);
            if (!groupedMap.has(label)) groupedMap.set(label, []);
            groupedMap.get(label)!.push(entry);
          }
          
          this.groupedDeviceActionHistory = Array.from(groupedMap.entries()).map(([label, entries]) => ({
            label,
            entries,
          }));


  }








    getFormattedLabel(dateString: string): string {
      const date = new Date(dateString); // or parseISO if string ends with Z or timezone

      const label = isToday(date)
        ? 'Today'
        : isYesterday(date)
        ? 'Yesterday'
        : format(date, 'EEEE');

      const displayDate = format(date, 'MMMM dd yyyy').toUpperCase(); // e.g., APRIL 20 2023

      return `${label}, ${displayDate}`;
    }


    getActionTimeDisplay(dateString: string): string {
      const date = new Date(dateString);
      if (isToday(date)) {
        return formatDistanceToNow(date, { addSuffix: true }); // e.g., '23 minutes ago'
      } else {
        return format(date, 'hh:mm a'); // e.g., '05:24 PM'
      }
    }



    getOperationLabel(device: string, operation: string, metadata:actionMetadataModel): string {


      if (operation === "schedule"){
        return this.scheduleActionProcessing(device, operation, metadata)
        // this.config = OPERATION_SCHEDULE_CONFIGS[operation] || OPERATION_CONFIGS['default'];
        // return;
      }
      else{
     if (operation === "intelligent_mode_off" && metadata?.dependent_operation === "winter_mode"){

          operation = metadata.dependent_operation
      }
      else if (metadata.controller_activated_winter_mode){

          operation = metadata.controller_activated_winter_mode

      }

      this.config = OPERATION_CONFIGS[operation] || OPERATION_CONFIGS['default'];
      }
      

      return this.config.labelTemplate
        .replace('{{device}}', device)
        .replace('{{operation}}', operation)
        .replace('{{previous_value}}', metadata.previous_value || '')
        .replace('{{current_value}}', metadata.current_value || '')
        .replace('{{schedule_name}}', metadata.schedule_name || '')
        .replace('{{start_time}}', metadata.start_time || '')
        .replace('{{end_time}}', metadata.end_time || '');

    }

    getOperationIcon(operation: string): string {
      const config = OPERATION_CONFIGS[operation] || OPERATION_CONFIGS['default'];
      return config.iconPath;
    }


  getUserImage(history:DeviceActionHistoryModel) {

    const image = history.files_id

    const profileImage = this.auth.getInstallerImages(image);
    if (profileImage) {
      return profileImage;
    }
    
    const operation_performed = history.operation_performed
    const intelligentOperations = ["intelligent_mode_rpm","intelligent_mode_resumed","intelligent_mode_paused"]
    if (intelligentOperations.includes(operation_performed))
      {
      return 'assets/img/intelligent-mode-on-action-history.svg';

    }
    
    const firstname = history.firstname
    const lastname = history.lastname
    if (!firstname && !lastname){
      return 'assets/img/settings-profile.svg';

    }
    return 'assets/default-image.svg';
  }

onScroll(event: any) {
  const element = event.target;
  const atBottom = element.scrollHeight - element.scrollTop === element.clientHeight;
    if (atBottom && !this.loading && !this.allLoaded) {
      this.loadMore();
    }
}


getDisplayName(history:DeviceActionHistoryModel): string {

    const firstname = history.firstname
    const lastname = history.lastname

    if (firstname || lastname) {
      return `${firstname || ''} ${lastname || ''}`;
    } 
    const operationPerformed = history.operation_performed
    const intelligentOperations = ["intelligent_mode_rpm","intelligent_mode_resumed","intelligent_mode_paused"]

    if (intelligentOperations.includes(operationPerformed)) {
      return 'Intelligent Mode';
    } 
    return 'Controller';
    
  }


async loadMore() {
    this.loading = true;



    try {
      const data = await this.controllerService.get_device_action_history(
        this.controllerDetails.controller_uuid,
        this.controllerDetails.device_id!,
        this.selectedActions,
        this.offset
      );
      if (data.length === 0) {
        this.allLoaded = true;
      } else {
        this.deviceActionHistory.push(...data)
        this.historyGrouping()
        this.offset += 1;
      }
    } catch (err) {
      console.error('Error fetching data', err);
    } finally {
      this.loading = false;
    }
  }










scheduleActionProcessing(device: string, operation: string, metadata: any): string {
  // Reject if missing start_time or end_time
  if (!metadata.start_time?.[0] || !metadata.end_time?.[0]) {
    return '';  // empty string for template safety
  }

  if (metadata.operation_type) {
    operation = metadata.operation_type;
  } else if (metadata.status) {
    operation = metadata.status;
  }

  this.config = OPERATION_SCHEDULE_CONFIGS[operation] || OPERATION_SCHEDULE_CONFIGS['default'];

  return this.config.labelTemplate
    .replace('{{device}}', device)
    .replace('{{operation}}', operation)
    .replace('{{previous_value}}', metadata.previous_value || '')
    .replace('{{current_value}}', metadata.current_value || '')
    .replace('{{schedule_name}}', metadata.schedule_name || '')
    .replace('{{start_time}}', this.convertTimeToTimeZone(metadata.start_time[0], this.controllerDetails.time_zone!))
    .replace('{{end_time}}', this.convertTimeToTimeZone(metadata.end_time[0], this.controllerDetails.time_zone!))
    .replace('{{schedule_type}}', metadata.schedule_type || '');
}


  convertToLocalTime(utcTime: string, zone: string): string {
    return DateTime.fromISO(utcTime, { zone: 'utc' })
                   .setZone(zone)
                   .toFormat('yyyy-MM-dd HH:mm:ss'); // or customize format
  }



toggleEchodium(operationId: string): void {
  this.echodiumStates[operationId] = !this.echodiumStates[operationId];
}


isEchodiumOpen(operationId: string): boolean {
  return !!this.echodiumStates[operationId];
}


getSubOperationLabel(operation_info:OperationInfoModel): string {
  const device = operation_info.device_id

  this.operation = operation_info.operation
  const success = operation_info.success
  
    if (success === 0){
      this.operation = "failed"
      this.subOperation = "{{device}} error occurred"

    }
        else if(this.operation === "set_600_rpm") {
    this.subOperation = "{{device}}"
    }
    else if(this.operation === "turn_on") {
    this.subOperation = "{{device}} ON"
    }
    else if(this.operation === "set_3000_rpm") {
    this.subOperation = "{{device}} set speed to high"
    }

    else{
    this.subOperation = "{{device}} OFF"
    }
  return this.subOperation.replace('{{device}}', device).replace('{{operation}}', this.operation)

}






 convertTimeToTimeZone(time: string, timeZone: string): string {
  // Create a DateTime from the time (assumes it's in UTC or base time)
  const [hour, minute] = time.split(':').map(Number);
  const dt = DateTime.utc().set({ hour, minute, second: 0 }).setZone(timeZone);

  return dt.toFormat('hh:mm a'); // e.g., '06:54 PM'
}

resetSelection(): void {

  this.selectedActions = this.action_filters.map(config => config.value);
}



    filterPopUp(){
      this.popUp = true
    }


closeModalFilter(){
  this.popUp = false
}




  toggleAction(value: string): void {
    const index = this.selectedActions.indexOf(value);
    if (index === -1) {
      this.selectedActions.push(value);
    } else {
      this.selectedActions.splice(index, 1);
    }
  }



async submitFilters(): Promise<void> {
  if (this.selectedActions?.length){
  this.deviceActionFilters = {
    unique_filters: [...this.selectedActions]
  };


      this.deviceActionHistory = await this.controllerService.get_device_action_history(
        this.controllerDetails.controller_uuid,
        this.controllerDetails.device_id!,
        this.selectedActions
      );

        this.historyGrouping();
    }
  this.popUp = false;
  this.isFilterSelected = this.selectedActions.length > 0
}

    modalClose(){
      this.closeModal.emit(true)
      this.confirmationDialogService.closeDialog(true)
    }
    }
  